/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 42,
    height: 32,
    viewBox: '0 0 42 32',
    data: '<path pid="0" _fill="#757575" d="M42.199 15.401a1.62 1.62 0 00-.331-.496L27.417.454a1.548 1.548 0 00-2.188 2.188l-.001-.001L37.037 14.45H1.548a1.548 1.548 0 100 3.096h35.489L25.228 29.355c-.28.28-.453.667-.453 1.094s.173.814.453 1.094c.28.28.667.453 1.094.453s.814-.173 1.094-.453l14.452-14.452c.144-.161.257-.354.327-.567l.003-.011a1.497 1.497 0 00-.004-1.125l.004.01z"/>'
  }
})
